import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './CancellationPolicyDisplay.module.css';

/**
 * A component to display the cancellation policy of a listing.
 *
 * @param {Object} props
 * @param {string} props.cancellationPolicy - 'flexible', 'moderate', 'strict', or 'custom'
 * @param {Object} [props.cancellationPolicyConfig] - Used to extract custom policy details
 * @param {string} [props.className] - custom class
 * @param {string} [props.rootClassName] - root class
 */
const CancellationPolicyDisplay = props => {
  const { cancellationPolicy, cancellationPolicyConfig, className, rootClassName, showHeading = true } = props;
  const policy = cancellationPolicy || 'moderate';
  const policyKey = policy.charAt(0).toUpperCase() + policy.slice(1);

  const classes = classNames(rootClassName || css.root, className);
  
  const isCustom = policy === 'custom';
  
  // Extract custom tiers
  const tiers = [];
  if (isCustom && cancellationPolicyConfig) {
    [1, 2, 3].forEach(i => {
      const hours = cancellationPolicyConfig[`customCancellationTimeframe${i}Hours`];
      const refund = cancellationPolicyConfig[`customCancellationRefund${i}Percentage`];
      if (hours !== undefined && hours !== null && refund !== undefined && refund !== null) {
        tiers.push({ hours, refund });
      }
    });
    // Sort descending by hours
    tiers.sort((a, b) => b.hours - a.hours);
  }

  return (
    <div className={classes}>
      {showHeading ? (
        <h3 className={css.title}>
          <FormattedMessage id="ProfileSettingsForm.cancellationPolicyHeading" />
        </h3>
      ) : null}
      {isCustom && tiers.length > 0 ? (
        <ul className={css.customList}>
          {tiers.map((tier, index) => (
            <li key={index} className={css.customListItem}>
              {tier.refund}% refund up to {tier.hours}h before rental
            </li>
          ))}
          <li className={css.customListItem}>
             0% refund if cancelled within {tiers[tiers.length - 1].hours}h of rental
          </li>
        </ul>
      ) : (
        <p className={css.description}>
          <FormattedMessage id={`ProfileSettingsForm.cancellationPolicy${policyKey}`} />
        </p>
      )}
    </div>
  );
};

export default CancellationPolicyDisplay;
